import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-medium);
	display: flex;
	flex-direction: column;
	gap: var(--gap);
`;
